const ClevertapReact = {
  initialize: function (
    accountId,
    customerName,
    customerId,
    customerMobile,
    clevertap_profile_details,
  ) {
    window.clevertap = {
      event: [],
      profile: [],
      account: [],
      onUserLogin: [],
      region: 'in1',
      notifications: [],
      privacy: [],
    };
    window.clevertap.account.push({ id: accountId, region: 'in1' });
    window.clevertap.privacy.push({ optOut: false }); //set the flag to true, if the user of the device opts out of sharing their data
    window.clevertap.privacy.push({ useIP: false }); //set the flag to true, if the user agrees to share their IP data

    window.clevertap.onUserLogin.push({
      Site: {
        Name: customerName, // String
        Identity: customerId, // String or number
        Phone: customerMobile !== '' ? '+91' + customerMobile : '', // Phone (with the country code)
        // optional fields. controls whether the user will be sent email, push etc.
        'MSG-email': false, // Disable email notifications
        'MSG-push': true, // Enable push notifications
        'MSG-sms': false, // Enable sms notifications
        'MSG-whatsapp': true, // Enable WhatsApp notifications
      },
    });

    let profileDetails = {};
    try {
      profileDetails =
        typeof clevertap_profile_details === 'string'
          ? JSON.parse(clevertap_profile_details)
          : clevertap_profile_details;
    } catch (err) {
      console.warn('err', err);
    }
    window.clevertap.profile.push({
      Site: profileDetails,
    });

    // Sample for Profile & Event
    // window.clevertap.profile.push({
    //   "Site": {
    //     "Customer Type": "Silver",
    //     "Prefered Language": "English"
    //   }
    // });

    // window.clevertap.event.push('test_data', {
    //   "Event Name": "pwa_enter",
    //   "Event Category": "pwa",
    //   "Event Description": "test",
    //   "Event Date": new Date()
    // });

    //
    (function () {
      var wzrk = document.createElement('script');
      wzrk.type = 'text/javascript';
      wzrk.async = true;
      wzrk.src =
        ('https:' === document.location.protocol
          ? 'https://d2r1yp2w7bby2u.cloudfront.net'
          : 'http://static.clevertap.com') + '/js/clevertap.min.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(wzrk, s);
    })();
  },

  event: function (name, payload) {
    if (payload) {
      window.clevertap.event.push(name, payload);
    } else {
      window.clevertap.event.push(name);
    }
  },

  profile: function (payload) {
    window.clevertap.profile.push(payload);
  },

  logout: function () {
    window.clevertap.logout();
  },
};

export default ClevertapReact;
